import { ApolloClient, InMemoryCache, createHttpLink, from, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';


const resolveApiBaseUrl = (): string => {
  const runtimeBase = typeof window !== 'undefined' && (window as any).RUNTIME_CONFIG?.REACT_APP_API_BASE_URL;
  if (runtimeBase) return runtimeBase as string;
  const buildTimeBase = process.env.REACT_APP_API_BASE_URL;
  if (buildTimeBase) return buildTimeBase as string;
  return 'https://flow888.win';
};

const resolveWsBaseUrl = (): string => {
  const httpBase = resolveApiBaseUrl();
  return httpBase.replace(/^http/, 'ws');
};

const httpLink = createHttpLink({
  uri: `${resolveApiBaseUrl()}/graphql`,
  credentials: 'include', // Include credentials for CORS
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    }
  }
});

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  console.log({ graphQLErrors });

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      if(extensions?.code === 'UNAUTHENTICATED') {
        // Handle unauthenticated error
        console.log('Unauthenticated error', extensions?.code);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
        //remove accesToken from localstorrage
      }
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}, Extensions: ${JSON.stringify(extensions)}`,
      );
    });
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);

    // Handle specific network errors
    // if (networkError?.statusCode === 401) {
    //   // Unauthorized - clear auth token and redirect to login
    //   localStorage.removeItem('authToken');
    //   // You might want to redirect to login page here
    // }
  }
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: `${resolveWsBaseUrl()}/graphql`,
    connectionParams: () => {
      const token = localStorage.getItem('authToken');
      return {
        Authorization: token ? `Bearer ${token}` : '',
      };
    },
    on: {
      connected: (socket) => {
      },
      error: (error) => {
        console.error('[WebSocket] ❌ Connection error:', error);
      },
      closed: (event) => {
      },
      connecting: () => {
      },
    },
  }),
);

// const wsLink = typeof window !== 'undefined'
//   ? new GraphQLWsLink(createClient({
//       url: `${resolveWsBaseUrl()}/graphql`,
//       lazy: true,
//       retryAttempts: 10,
//       retryWait: async (retries) => {
//         const ms = Math.min(1000 * 2 ** retries, 10000);
//         await new Promise((r) => setTimeout(r, ms));
//       },
//       connectionParams: () => {
//         const token = localStorage.getItem('authToken');
//         if (!token) return {};
//         return {
//           Authorization: `Bearer ${token}`,
//           headers: {
//             authorization: `Bearer ${token}`,
//           },
//         };
//       },
//     }))
//   : null as unknown as GraphQLWsLink;


const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  from([errorLink, authLink, httpLink]),
);

// Create Apollo Client instance
export const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

// const terminatingHttpLink = from([errorLink, authLink, httpLink]);

// const splitLink = typeof window !== 'undefined' && wsLink
//   ? split(
//       ({ query }) => {
//         const definition = getMainDefinition(query);
//         return (
//           definition.kind === 'OperationDefinition' &&
//           definition.operation === 'subscription'
//         );
//       },
//       wsLink,
//       terminatingHttpLink
//     )
//   : terminatingHttpLink;

// const client = new ApolloClient({
//   link: splitLink,
//   cache: new InMemoryCache({

//   }),
//   defaultOptions: {
//     watchQuery: {
//       errorPolicy: 'all',
//     },
//     query: {
//       errorPolicy: 'all',
//     },
//   },
// });

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

export default client;
